// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9e9b5310","488":"b51d605a","977":"470ec7d1"}[chunkId] + ".chunk.js";
};